import * as Sentry from '@sentry/browser'
import { envUrl, envVar } from '@babylon/babylon-env'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

const logException = (e: Error) => {
  const logEx = envUrl('SENTRY_DSN') ? Sentry.captureException : console.error
  logEx(e)

  if (envVar('DD_APP_ID')) {
    datadogRum.addError(e)
  }
  datadogLogs.logger.error(e.message, {}, e)
}

export default logException
